<script setup lang="ts">
const { t } = useI18n()

const props = defineProps<{
  open: boolean
}>()

const emit = defineEmits<{
  (e: "cancel", value: void): void
  (e: "submit", value: void): void
}>()

function cancel() {
  emit("cancel")
}

function submit() {
  emit("submit")
}
</script>

<template>
  <div class="relative z-20" aria-labelledby="modal-title" role="dialog" aria-modal="true" @click.prevent.stop="{}">
    <Transition name="backdrop">
      <div v-show="props.open" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
    </Transition>
    <Transition name="modal">
      <div v-show="props.open" class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          @click.self="cancel"
          class="flex min-h-full items-end justify-center p-4 text-center mobile:items-center"
          :title="t('jc.component.modal.closeHint')"
        >
          <form
            @submit.prevent="submit"
            @keydown.esc="cancel"
            novalidate
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all mobile:my-8 w-full mobile:max-w-lg"
          >
            <slot />
          </form>
        </div>
      </div>
    </Transition>
  </div>
</template>

<!--suppress CssUnusedSymbol -->
<style scoped lang="postcss">
.backdrop-enter-active {
  @apply transition-opacity ease-out duration-300
}

.backdrop-leave-active {
  @apply transition-opacity ease-in duration-200
}

.backdrop-enter-from {
  @apply opacity-0
}

.backdrop-enter-to {
  @apply opacity-100
}

.backdrop-leave-from {
  @apply opacity-100
}

.backdrop-leave-to {
  @apply opacity-0
}

.modal-enter-active {
  @apply transition-all ease-out duration-300
}

.modal-leave-active {
  @apply transition-all ease-in duration-200
}

.modal-enter-from {
  @apply opacity-0 translate-y-4 mobile:translate-y-0 mobile:scale-95
}

.modal-enter-to {
  @apply opacity-100 translate-y-0 mobile:scale-100
}

.modal-leave-from {
  @apply opacity-100 translate-y-0 mobile:scale-100
}

.modal-leave-to {
  @apply opacity-0 translate-y-4 mobile:translate-y-0 mobile:scale-95
}
</style>
